import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { FAQS } from "@/components/Faq";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { QuoteSection } from "@/components/QuoteSection";
import { Faq } from "@/components/Faq";
import { ServiceArea } from "@/components/ServiceArea";
import { Footer } from "@/components/Footer";
import { StickyCallBar } from "@/components/StickyCallBar";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const scripts = [
      {
        id: "ld-local-business",
        data: {
          "@context": "https://schema.org",
          "@type": "ChimneySweep",
          name: "Exotictileandmasonry",
          description:
            "Chimney sweeping, chimney repair, crowns, caps, flashing, tuckpointing, fireplace glass doors, and emergency escrow chimney service serving the greater Portland, Oregon area.",
          url: "https://pdx-chimney-pro.emergent.host",
          telephone: "+1-971-255-3874",
          priceRange: "$249",
          areaServed: ["Portland", "Hillsboro", "Clackamas", "Beaverton", "Tualatin"].map(
            (name) => ({ "@type": "City", name: `${name}, OR` })
          ),
          makesOffer: {
            "@type": "Offer",
            name: "Chimney Sweeping with Free Inspection",
            price: "249",
            priceCurrency: "USD",
          },
        },
      },
      {
        id: "ld-faq",
        data: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        },
      },
    ];
    scripts.forEach(({ id, data }) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    });
    return () => scripts.forEach(({ id }) => document.getElementById(id)?.remove());
  }, []);

  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <QuoteSection />
        <Faq />
        <ServiceArea />
      </main>
      <Footer />
      <StickyCallBar />
    </div>
  );
}
